<template>
  <card header='Progress'>
    <div class="flex flex-column">
      <div v-for="(bucket, index) in charts" :key="index" class="mv1">
        <div class="flex flex-column">
          <span class="db f6 pb1 silver">{{ bucket.label }}</span>
          <svg-progress :data="bucket.one" class="mb1"></svg-progress>
          <svg-progress :data="bucket.two"></svg-progress>
        </div>
      </div>
    </div>
    <table class="w-100 clip" cellspacing="0">
      <tr v-for="(bucket, index) in charts" :key="index">
        <td class="f7 ma0 pa0 pt2 pb1">
          <span class="db pb1 silver">{{ bucket.label }}</span>
        </td>
        <td>
          <div class="flex flex-column ml2">
            <!--
            <div class="flex justify-between f7 mb1">
              <div class="f6">{{ chart.series.value.toLocaleString('ru-RU') }} р.</div>
              <div class="silver">{{ chart.series.total.toLocaleString('ru-RU') }} р.</div>
            </div>
            -->
            <svg-progress :data="bucket.one" class="mv1"></svg-progress>
            <svg-progress :data="bucket.two"></svg-progress>
          </div>
        </td>
      </tr>
    </table>
  </card>
</template>

<script>
import Card from './Card.vue'
import SvgProgress from '@/components/charts/svg/Progress.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    Card,
    SvgProgress
  },
  data () {
    return {
      data: {
        style: {
          color: colors[9]
        },
        series: {
          value: 23724205,
          total: 142345234
        }
      },
      data2: {
        style: {
          color: colors[9]
        },
        series: {
          value: 9362102,
          total: 112345234
        }
      },
      items: [
        { value1: 23724205, value2: 142345234, label: 'Апрель' },
        { value1: 112345234, value2: 9362102, label: 'Май' },
        { value1: 132345234, value2: 16543154, label: 'Июнь' },
        { value1: 25390872, value2: 152345234, label: 'Июль' },
        { value1: 92345234, value2: 6156348, label: 'Август' },
        { value1: 28086308, value2: 112345234, label: 'Сентябрь' },
        { value1: 100045234, value2: 7695787, label: 'Октябрь' },
        { value1: 100045234, value2: 7695787, label: 'Ноябрь' },
        { value1: 8670436, value2: 104045234, label: 'Декабрь' },
        { value1: 134045234, value2: 9574659, label: 'Январь' },
        { value1: 14007539, value2: 84045234, label: 'Февраль' },
        { value1: 124045234, value2: 17720747, label: 'Март' }
      ]
    }
  },
  computed: {
    max () {
      return this.$lo.maxBy(this.items, (o) => { return Math.max(o.value1, o.value2) })
    },
    charts () {
      const o = this.max
      const max = Math.max(o.value1, o.value2)

      return this.items.map(({ value1, value2, label }) => {
        return {
          label,
          one: {
            series: { value: value1, total: max },
            style: { color: colors[9], showBase: false }
          },
          two: {
            series: { value: value2, total: max },
            style: { color: colors[3], showBase: false }
          }
        }
      })
    }
  }
}
</script>
